import * as React from 'react';
import classNames from 'classnames';

interface LoadingProps {
  show: boolean;
}


const Loading = ({ show }: LoadingProps) => (
  <div className={classNames('loading', { 'is-hiding': !show })}>
    <div className="ball-triangle-path">
      <div className="ball-1" />
      <div className="ball-2" />
      <div className="ball-3" />
    </div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx